// extracted by mini-css-extract-plugin
module.exports = {"gwContactsTabContainer":"Contacts_gwContactsTabContainer__25qNI","gwTitleStyle":"Contacts_gwTitleStyle__2fAFJ"};